import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';

import { TypedDialogModule } from '@libs/src/typed-dialog/typed-dialog.module';

@Component({
  imports: [CommonModule, TypedDialogModule],
  selector: 'app-dialog-header',
  standalone: true,
  styleUrls: ['./dialog-header.component.scss'],
  templateUrl: './dialog-header.component.html',
})
export class DialogHeaderComponent {
  @Input() title: string;
  @Input() subtitle: string;
}
